import { TypeOf } from '@guiker/yup-util'

import { stockSchema } from './stock-schema'

export const createStockSchema = stockSchema

export type CreateStockSchema = TypeOf<typeof createStockSchema>
